import { useEffect } from "react";
import Seo from "../components/Seo";
import { Youtube, ArrowRight } from "lucide-react";

const YOUTUBE_CHANNEL = "https://www.youtube.com/@MechelenBeach";

const VIDEOS = [
  {
    title: "Aftermovie 1",
    youtubeId: "yXQC9ruD4G8",
    url: "https://www.youtube.com/watch?v=yXQC9ruD4G8",
  },
  {
    title: "Aftermovie 2",
    youtubeId: "ssGp4KuQvoY",
    url: "https://www.youtube.com/watch?v=ssGp4KuQvoY",
  },
];

const SHORTS = [
  { title: "Mechelen Beach — Short 1", youtubeId: "vvFaO7GMRCQ" },
  { title: "Mechelen Beach — Short 2", youtubeId: "pWfoew10hSs" },
  { title: "Mechelen Beach — Short 3", youtubeId: "wXSs0SlI0Kc" },
];

export default function Videos() {
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash.replace(/^#/, "");
      if (!hash) return;
      const el = document.getElementById(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      }
    };
    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  return (
    <>
      <Seo
        title="Video's | Mechelen Beach 2026"
        description="Bekijk aftermovies en video's van Mechelen Beach op ons YouTube-kanaal."
      />

      <section
        id="aftermovie-2026"
        data-testid="videos-aftermovie-2026"
        className="bg-warm-gradient pt-16 sm:pt-20 lg:pt-24 pb-12 sm:pb-16 scroll-mt-24"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6 sm:mb-8">
            <span className="eyebrow">Nieuw</span>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Mechelen Beach aftermovie 2026
            </h2>
            <p className="mt-3 text-sm sm:text-base text-[#6b5945] leading-relaxed max-w-2xl">
              Herbeleef de zomer van 2026 — de officiële aftermovie is er.
            </p>
          </div>
          <article
            data-testid="video-aftermovie-2026-card"
            className="group rounded-2xl overflow-hidden border border-[#ebd9b5] bg-white shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]"
          >
            <div className="relative w-full aspect-video bg-[#0b1722]">
              <iframe
                src="https://www.youtube-nocookie.com/embed/H-ugYyYKuGM?rel=0"
                title="Mechelen Beach aftermovie 2026"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="absolute inset-0 h-full w-full"
              />
            </div>
            <div className="p-5 sm:p-6 flex items-center justify-between gap-4">
              <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#2b1c10]">
                Aftermovie 2026
              </h3>
              <a
                href="https://www.youtube.com/watch?v=H-ugYyYKuGM"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="video-aftermovie-2026-watch-btn"
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#ed6a1a] hover:text-[#c54508] transition-colors whitespace-nowrap"
              >
                Bekijk op YouTube
                <ArrowRight className="h-3.5 w-3.5" />
              </a>
            </div>
          </article>
        </div>
      </section>

      <section className="bg-warm-gradient">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 pb-8 sm:pb-10">
          <div className="max-w-2xl">
            <span className="eyebrow">Media</span>
            <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
              Video&apos;s van Mechelen Beach
            </h1>
            <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
              Beleef de sfeer van vorige edities opnieuw in onze aftermovies en
              bekijk alle video&apos;s op ons YouTube-kanaal.
            </p>
            <a
              href={YOUTUBE_CHANNEL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="video-youtube-channel-btn"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-orange-gradient text-white px-6 py-3 text-sm font-semibold shadow-[0_10px_30px_-12px_rgba(237,106,26,0.7)] hover:opacity-95 transition"
            >
              <Youtube className="h-4 w-4" />
              Bekijk ons YouTube-kanaal
              <ArrowRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </section>

      <section
        data-testid="videos-grid"
        className="bg-warm-gradient pb-16 sm:pb-20"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
            {VIDEOS.map((v, i) => (
              <article
                key={v.youtubeId}
                data-testid={`video-card-${i}`}
                className="group rounded-2xl overflow-hidden border border-[#ebd9b5] bg-white shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]"
              >
                <div className="relative w-full aspect-video bg-[#0b1722]">
                  <iframe
                    src={`https://www.youtube-nocookie.com/embed/${v.youtubeId}?rel=0`}
                    title={v.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="absolute inset-0 h-full w-full"
                  />
                </div>
                <div className="p-5 sm:p-6 flex items-center justify-between gap-4">
                  <h2 className="font-display text-xl sm:text-2xl font-semibold text-[#2b1c10]">
                    {v.title}
                  </h2>
                  <a
                    href={v.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`video-watch-btn-${i}`}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#ed6a1a] hover:text-[#c54508] transition-colors whitespace-nowrap"
                  >
                    Bekijk op YouTube
                    <ArrowRight className="h-3.5 w-3.5" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section
        data-testid="videos-shorts"
        className="bg-warm-gradient pb-16 sm:pb-20"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6 sm:mb-8">
            <span className="eyebrow">Shorts</span>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              YouTube Shorts
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto lg:mx-0">
            {SHORTS.map((s, i) => (
              <article
                key={s.youtubeId}
                data-testid={`video-short-${i}`}
                className="group rounded-2xl overflow-hidden border border-[#ebd9b5] bg-white shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]"
              >
                <div className="relative w-full aspect-[9/16] bg-[#0b1722]">
                  <iframe
                    src={`https://www.youtube-nocookie.com/embed/${s.youtubeId}?rel=0`}
                    title={s.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="absolute inset-0 h-full w-full"
                  />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
